module.exports = __webpack_public_path__ + "img/vertical_7_5_8003.c228af2d.png";